import { action } from 'satcheljs';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import { ActionSource } from 'owa-analytics-actions';

export default action(
    'SET_ITEMS_FLAG_STATE_BASED_ON_NODE_IDS',
    (
        nodeIds: string[],
        tableViewId: string,
        flagStatusToSet: FlagStatus,
        actionSource: ActionSource
    ) => ({
        nodeIds,
        tableViewId,
        flagStatusToSet,
        actionSource,
    })
);
